import script from "./ProjectsGrid.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectsGrid.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__